import { ListNextActionEntity } from '../../types/assessments/assessment'
import { InsuranceCoverage, PatientCoverageId } from '../../types/insurance/coverage'

export const getIsGynProfile = (assessmentName?: string) =>
  !!assessmentName?.toLowerCase().split(' ').includes('gyn')

export const gynNextActionEntity: ListNextActionEntity = { type: 'gyn' }
export const getCoverageNextActionEntity = (
  id: PatientCoverageId,
  coverage: InsuranceCoverage | null | undefined,
): ListNextActionEntity => ({
  coverage,
  id,
  type: 'coverage',
})
